module.exports = __webpack_public_path__ + "static/media/iq.fb1c4e97.svg";